import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAlert } from "react-alert";

import { MyContext, ListContext } from "./MyContext";
import {
  Td,
  StyledTr,
  TableText2,
  Th,
  HelpText,
  StyledLink,
} from "./styleCustom";
// import AuthHelperMethods from "./AuthHelperMethods";
import COLORS from "./styleConstants";
import { Check } from "./icons";
import { OrangeLinkButton, TableHeaderNoAdd } from "./formComponents";
import ProductForm from "./productForm";
import ProductAssignProgram from "./productAssignProgram";
import PrivateRoute from "./privateRoute";
import { Active } from "./searchFilterReports";
import { active_options } from "./Constants2";
import Auth from "./Auth";
import { FeatureNotice, hasFeatureAccess } from "./featureAccess";

import { useState } from "react";

const ProductTable = (props) => {
  const { listState, dispatch2 } = useContext(ListContext);
  const { mystate, dispatch } = useContext(MyContext);

  const [showRecurringModal, setShowRecurringModal] = useState(false);
  const [recurringProduct, setRecurringProduct] = useState(null);

  const isAdmin = true;
  const baseurl = "/admin/setup/packages";
  const alert = useAlert();
  const canManageClientSubscriptions = hasFeatureAccess(
    mystate.farmDefaults,
    "clientSubscriptions",
  );

  useEffect(
    () => {
      let params = { ...listState.filter };

      const fetchData = async () => {
        const result = await Auth.api("products/index", "get", params);
        let products = result.data;

        dispatch2(["PRODUCTS_GET", result.data]);
      };
      fetchData();
    },
    //eslint-disable-next-line
    [listState.filter],
  );

  useEffect(
    () => {
      return () => {
        dispatch2([
          "SET_SEARCH_FILTER_RADIO",
          { ...listState.filter, is_active: "1" },
        ]);
      };
    },
    //eslint-disable-next-line
    [],
  );

  useEffect(
    () => {
      const fetchData = async () => {
        const result = await Auth.api("product_programs/index", "get");
        dispatch2(["PRODUCT_PROGRAMS_GET", result.data]);
      };
      fetchData();
    },
    //eslint-disable-next-line
    [],
  );

  /*const createProductInStripe = async (product) => {
    try {
      let params = { ...product, price: parseInt(product.product_price * 100) };
      const result = await Auth.api(
        "products/createProductInStripe",
        "post",
        params,
      );
      if (result && result.data) {
        dispatch2(["PRODUCTS_GET", result.data]);
        alert.success(
          `Product '${product.product_name}' set as recurring successfully.`,
        );
      } else {
        alert.error("No response data received from server.");
      }
    } catch (error) {
      console.error("Error creating product in Stripe:", error);
      if (error && error.message) {
        alert.error(`Failed to set as recurring: ${error.message}`);
      } else {
        alert.error("An unknown error occurred while setting as recurring.");
      }
    }
  };
  */

  const handleClickEditProduct = (product) => {
    console.log();
    console.log(product);
    dispatch2(["SET_CURRENT_LIST_DETAIL", product]);
    let formInitialValues = {
      id: product.id,
      name: product.product_name || "",
      desc: product.product_desc || "",
      price: product.product_price || "",
      count: product.product_count || "",
      purchase_online: product.purchase_online || false,
      expires_in: product.expires_in || "",
      is_tracked: product.is_tracked,
      renew_day_of_month: product.is_auto ? product.renew_day_of_month : "no",
    };
    dispatch2(["SET_FORM_INITIAL_VALUES", formInitialValues]);
  };

  const getSingleProductPrograms = (productId) => {
    console.log("getSingleProductPrograms");
    return (
      listState.productPrograms
        //.filter(item => item.product_id === productId)
        //.map(item2 => item2.name)
        .reduce((acc, { product_id, name }) => {
          if (product_id === productId) {
            acc.push(name);
          }
          return acc;
        }, [])
        .join(", ")
    );
  };

  const updateIsActive = async (id) => {
    let params = { ...listState.filter };
    params.id = id;
    const result = await Auth.api(
      "products/updateActivationStatus",
      "post",
      params,
    );
    // dispatch2(["GET_SECTION_LIST", result.data]);
    //dispatch2(["SECTION_EDIT", result.data]);
    //dispatch2(["GET_SECTION_LIST", result.data]);
    dispatch2(["PRODUCTS_GET", result.data]);

    console.log(result.data);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flex: "1 1 100%",
          justifyContent: "center",
        }}
      >
        <PrivateRoute
          path={`${props.match.url}/packageform/:addoredit`}
          component={ProductForm}
        />
        <PrivateRoute
          path={`${props.match.url}/packageprogram/:id`}
          component={ProductAssignProgram}
        />
      </div>
      <TableHeaderNoAdd title="Packages">
        <Link to={`${props.match.url}/packageform/add`}>
          <OrangeLinkButton>{"Add New Package"} </OrangeLinkButton>{" "}
        </Link>
      </TableHeaderNoAdd>
      <div style={{ display: "flex", flexDirection: "row", marginTop: 10 }}>
        <span style={{ marginRight: 10 }}>{"Showing:"}</span>
        <Active field={"is_active"} default={"1"} options={active_options} />
      </div>
      {listState.products && (
        <table style={{ width: "100%" }}>
          <thead>
            <tr style={{ color: `${COLORS.blue}` }}>
              <Th>
                {" "}
                <div>{"Name"}</div>
                <HelpText>{"Click on Product Name to edit"}</HelpText>
              </Th>
              <Th>Price</Th>
              <Th>Tracked</Th>
              <Th>Count</Th>

              <Th>Valid For (days)</Th>
              <Th>Online</Th>

              <Th>
                <div> {"Valid Programs"}</div>
                <HelpText>
                  {"Click on Valid Programs to Add/Remove associated programs"}
                </HelpText>
              </Th>
              <Th>Actions</Th>
            </tr>
          </thead>
          <tbody>
            {listState.products.length > 0 &&
              listState.products.map((product) => (
                <StyledTr key={product.id} recent={product.recent}>
                  <Td>
                    <StyledLink
                      to={`${props.match.url}/packageform/edit`}
                      onClick={() => handleClickEditProduct(product)}
                    >
                      <TableText2>{product.product_name} </TableText2>
                    </StyledLink>
                  </Td>
                  <Td>
                    <TableText2>
                      {`${mystate.farmDefaults.currency_symbol}${product.product_price}
                    `}
                    </TableText2>
                  </Td>
                  <Td>
                    <TableText2>
                      {product.is_tracked ? <Check /> : ""}
                    </TableText2>
                  </Td>

                  <Td>
                    <TableText2>{product.product_count}</TableText2>
                  </Td>

                  <Td>
                    <TableText2>{product.expires_in}</TableText2>
                  </Td>
                  <Td>
                    <TableText2>
                      {product.purchase_online ? <Check /> : ""}
                    </TableText2>
                  </Td>

                  <Td>
                    <Link
                      to={`${props.match.url}/packageprogram/${product.id}`}
                    >
                      <TableText2>
                        {getSingleProductPrograms(product.id) ||
                          "no assigned programs"}
                      </TableText2>
                    </Link>
                  </Td>

                  <Td>
                    <div
                      style={{ position: "relative", display: "inline-block" }}
                    >
                      {" "}
                      <button
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          fontSize: 18,
                          color: COLORS.orange,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          const dropdown = document.getElementById(
                            `actions-dropdown-${product.id}`,
                          );
                          if (dropdown)
                            dropdown.style.display =
                              dropdown.style.display === "block"
                                ? "none"
                                : "block";
                        }}
                        aria-label="Actions"
                      >
                        ▼
                      </button>
                      <div
                        id={`actions-dropdown-${product.id}`}
                        style={{
                          display: "none",
                          position: "absolute",
                          right: 0,
                          background: "#fff",
                          border: "1px solid #ccc",
                          boxShadowx: `0 2px 8px ${COLORS.orange}`,
                          zIndex: 10,
                          minWidth: 140,
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.display = "none";
                        }}
                      >
                        <div
                          style={{
                            padding: "8px 16px",
                            cursor: "pointer",
                            color: COLORS.orange,
                            fontWeight: "bold",
                          }}
                          onClick={() => {
                            updateIsActive(product.id);
                            document.getElementById(
                              `actions-dropdown-${product.id}`,
                            ).style.display = "none";
                          }}
                        >
                          {product.is_active ? "Inactivate" : "Activate"}
                        </div>
                        {/* product.is_active &&
                          !product.is_auto &&
                          mystate.farmDefaults.can_use_subscriptions && (
                            <div
                              style={{
                                padding: "8px 16px",
                                color: COLORS.orange,
                                fontWeight: "bold",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setRecurringProduct(product);
                                setShowRecurringModal(true);
                                document.getElementById(
                                  `actions-dropdown-${product.id}`,
                                ).style.display = "none";
                              }}
                            >
                              Add as Recurring
                            </div>
                          ) */}
                      </div>
                    </div>
                  </Td>
                </StyledTr>
              ))}
          </tbody>
        </table>
      )}
      {/* Recurring Modal */}
      {/* showRecurringModal && recurringProduct && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.3)",
            zIndex: 10000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 8,
              padding: 32,
              minWidth: 320,
              boxShadow: `0 2px 16px ${COLORS.orange}`,
              textAlign: "center",
            }}
          >
            <h2 style={{ color: COLORS.orange }}>Add as Recurring?</h2>
            <p>
              This will set <b>{recurringProduct.product_name}</b> as a
              recurring product in Stripe.
              <br />
              Are you sure you want to continue?
            </p>
            <div
              style={{
                marginTop: 24,
                display: "flex",
                justifyContent: "center",
                gap: 16,
              }}
            >
              <button
                style={{
                  background: COLORS.orange,
                  color: "#fff",
                  border: "none",
                  borderRadius: 4,
                  padding: "8px 24px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                onClick={() => {
                  createProductInStripe(recurringProduct);
                  setShowRecurringModal(false);
                  setRecurringProduct(null);
                }}
              >
                Yes
              </button>
              <button
                style={{
                  background: "#eee",
                  color: COLORS.orange,
                  border: `1px solid ${COLORS.orange}`,
                  borderRadius: 4,
                  padding: "8px 24px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setShowRecurringModal(false);
                  setRecurringProduct(null);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      ) */}
    </>
  );
};

export default ProductTable;
